import * as turf from '@turf/turf'
/**
 * 切换图层工具类
 */
export class ToggleLayer {
  /**
   * 初始化工具类
   * @param {Object} map 地图实例
   * @param {Array<String>} layers 当前图层列表
   */
  constructor(map, layers) {
    this.layers = layers
    this.store = Object.assign(layers)
    this.map = map
  }
  /**
   * 隐藏显示当前图层
   * @param {String} layerName
   * @returns {Boolean} 当前状态
   */
  toggle(layerName) {
    let map = this.map
    let index = this.store.indexOf(layerName)
    if (index >= 0) {
      map.setLayoutProperty(layerName, 'visibility', 'none')
      this.store.splice(index, 1)
      return true
    } else {
      map.setLayoutProperty(layerName, 'visibility', 'visible')
      this.store.push(layerName)
      return false
    }
  }
  /**
   * 按图层id模糊匹配，显示或隐藏图层
   * @param {String} layerId
   * @param {Boolean} show
   */
  toggleByLikeId(layerId, show) {
    let map = this.map
    let layers = map.getStyle().layers
    layers = layers.filter(item => item.id.includes(layerId))
    layers.forEach(item => {
      if (show) {
        map.setLayoutProperty(item.id, 'visibility', 'visible')
      } else {
        map.setLayoutProperty(item.id, 'visibility', 'none')
      }
    })
  }
}

/**
 *
 * 点位坐标转换为geojson
 * @param {Array<Number>} point
 */

export function pointToGeoJson(point) {
  let p = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: point
        }
      }
    ]
  }
  return p
}

/**
 *  添加 popup
 * @param {Object} map mapbox 实例
 * @param {String} el  dom id 或dom node
 * @param {Object} point 点位
 */
export function addPopup(map, el, { lat, lng }) {
  let option = {
    closeButton: false,
    closeOnClick: false,
    className: 'map-popup'
  }
  if (!el instanceof Object) {
    el = document.getElementById(id)
  }
  const popup = new mapboxgl.Popup(option)
    .setLngLat({ lat, lng })
    .setDOMContent(el)
    .addTo(map)
  return popup
}
import Animate from './animate'
export { Animate }



// WEBPACK FOOTER //
// ./src/framework/map/tool/index.js